import React from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer/indes";
import ContactUs from "../../Components/ContactingUs";
import Facebook from "../../Components/Facebook";
import Instagram from "../../Components/Instagram";
import WhatsApp from "../../Components/WhatsApp";
import { useForm, ValidationError } from "@formspree/react";
import "./Contact.css";

function Contact() {
  const [state, handleSubmit] = useForm("mrgdpjon");
  if (state.succeeded) {
    return <ContactUs />;
    // <p>Thanks for joining!</p>;
  }
  return (
    <>
      <div style={{ height: 80 }}>
        <Header />
      </div>

      <div className="contact-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.7068906710124!2d67.0000784143217!3d24.9420532481266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb34003b6ec2947%3A0xa3f79092bb672cb9!2sJuma%20Pan%20Shop!5e0!3m2!1sen!2s!4v1663436208453!5m2!1sen!2s"
          width="100%"
          height="500"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Map"
        ></iframe>
      </div>

      {/* Formmmmm */}

      <div className="form-contain">
        <div className="form-right">
          <h1>Contact Me</h1>
          <p className="form-right-first">Lets Work Together</p>
          <div className="right-div">
            <p>
              <i className="fa-solid fa-location-dot"></i> Farman & Sons
              Electric Shop Orangi Town No #5 Near Jumma Paan Shop
            </p>
            <p>
              <i className="fa-solid fa-envelope"></i> khanashhad555@gmail.com
            </p>
            <p>
              <i className="fa-solid fa-phone"></i> +923201276814
            </p>
          </div>
          <div className="icons-fonts">
            <div className="facebook">
              <a href="https://www.facebook.com/profile.php?id=100040363922834">
                <Facebook />
              </a>
            </div>
            <div>
              <a href="https://www.instagram.com/ashhadkhan_official/">
                <Instagram />
              </a>
            </div>
          </div>
        </div>
        <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <div>
              <input
                placeholder="Your Name"
                id="username"
                type="username"
                name="username"
                required
              />
            </div>
            <div>
              <input
                placeholder="Email Addrees"
                id="email"
                type="email"
                name="email"
                required
              />
              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
              />
            </div>
            <div>
              <textarea
                id="message"
                name="message"
                placeholder="Your Message"
                rows="4"
                required
              />
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />
            </div>
            <div>
              <button type="submit" disabled={state.submitting}>
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <WhatsApp />
      <Footer />
    </>
  );
}

export default Contact;
